'use client';

import a__default, { forwardRef } from "react";
import b from "../lib/IconBase.js";
import e from "../defs/Yarn.js";
var i = Object.defineProperty, n = Object.defineProperties;
var p = Object.getOwnPropertyDescriptors;
var a = Object.getOwnPropertySymbols;
var s = Object.prototype.hasOwnProperty, c = Object.prototype.propertyIsEnumerable;
var t = (e2, r, o) => r in e2 ? i(e2, r, { enumerable: true, configurable: true, writable: true, value: o }) : e2[r] = o, m = (e2, r) => {
  for (var o in r || (r = {}))
    s.call(r, o) && t(e2, o, r[o]);
  if (a)
    for (var o of a(r))
      c.call(r, o) && t(e2, o, r[o]);
  return e2;
}, f = (e2, r) => n(e2, p(r));
const R = forwardRef((e$1, r) => /* @__PURE__ */ a__default.createElement(b, f(m({ ref: r }, e$1), { weights: e })));
R.displayName = "Yarn";
export {
  R as Yarn
};
